React = require('react');
ReactDOM = require('react-dom');
FilterDesktop = require('../../components/filter_desktop/filter_desktop.js.jsx');

require('react_ujs');
